import { getValueByPath } from '../../../helpers/getValueByPath';

export const ascSort = (array, key = 'value') =>
  array.sort((a, b) => getValueByPath(b, key) - getValueByPath(a, key));
